// TODO: Is this a valid input type? Should it be removed or renamed? Investigate.

const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-DocumentDate`,
			// TODO: Make a Document Date Provider to update the document object and the header date
			Template: /*HTML*/`
			<!-- InputType DocumentDate {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field mb-0">
					<label for="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<input
							id="DATETIME-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							readonly aria-readonly="true"
							value="{~DateFormat:AppData.DocumentData.ReportData.DocumentDate^YYYY-MM-DD~}"
						/>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-DocumentDate`,
			Template: /*HTML*/`
			<!-- InputType DocumentDate {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							readonly aria-readonly="true"
							value="{~DateFormat:AppData.DocumentData.ReportData.DocumentDate^YYYY-MM-DD~}"
						/>
					</p>
				</div>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-DocumentDate`,
			Template: /*HTML*/`
			<!-- InputType DocumentDate {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
						>{~DateFormat:AppData.DocumentData.ReportData.DocumentDate^YYYY-MM-DD~}</div>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
